import cn from 'classnames';
import { motion } from 'framer-motion';
import React from 'react';
import Odds from 'shared/components/odds/container';
import { PlaceBet } from 'shared/interface';
import './styles.scss';
interface Props {
	className?: string;
	data: any;
	event: any;
	onClickOdds: (item: PlaceBet, e: React.MouseEvent) => void;
	eventUrl: any;
}

const CardAdditionalBet: React.FC<Props> = ({ data, event, onClickOdds, eventUrl }) => {
	const numberOfOutcomes = data.outcomes.length;
	const { sportId, eventStart, eventId, eventType, categoryId, eventName, sportName, parentName, categoryname } = event;
	const combineData = {
		...data,
		sportId,
		eventStart,
		eventId,
		eventType,
		categoryId,
		eventName,
		sportName,
		parentName,
		categoryname,
	};
	return (
		<motion.section className="additionalBet">
			<div className="additionalBet__title">{data.gameName}</div>
			<div
				className={cn(
					'additionalBet__odds',
					{ 'additionalBet__odds--double': numberOfOutcomes === 2 },
					{ 'additionalBet__odds--triple': numberOfOutcomes >= 3 },
				)}
			>
				<Odds eventUrl={eventUrl} onClickOdds={onClickOdds} data={combineData} />
			</div>
		</motion.section>
	);
};

export default CardAdditionalBet;
